import React from 'react'
import office from '../images/office.png'
import abctransport from '../images/abc.png'
import  './styles.css'

const About = () => {
  return (
    <>
        <section className="about section-padding pb-0" id="search">
          <div className="container">
               <div className="row">

                    <div className="col-lg-6 mx-auto col-md-6 col-12 mt-5">
                         <div className="about-info mt-5 px-6">

                              <h2 className="mb-4" data-aos="fade-up">Get all updates from our <strong>Digital Services !</strong></h2>

                              <p className="mb-0" data-aos="fade-up">Just in ABC Transport PLC Rights Issue. 
                              <br /><br />
                              
                              <p><strong> <span className='showacceptance'>Acceptance List Opens :  </span></strong>  {"  "}  {" "} &nbsp;&nbsp;  Monday May 16, 2022. <br/>  <p className='mt-3' ><strong> <span className='showacceptance'> Acceptance List Closes :  </span></strong> {"  "}  {" "} &nbsp;&nbsp;  Tuesday May 31, 2022    </p></p> 
                             
                               </p>
                         </div>

                       </div>

                       
                    <div className='col-lg-6 mx-auto col-md-6 col-12'>
                    <img src={abctransport} className="img-fluid" alt="abc-transport"data-aos="fade-down" data-aos-delay="300" />
                    </div>
                    
                    <div className='col-lg-7 mx-auto col-md-10 col-12'>
                    <div className="about-image" data-aos="fade-up" data-aos-delay="200">

                    <img src={office} className="img-fluid" alt="office" />
                    </div>
                    </div>

               </div>
          </div>
     </section>

     
    </>
  )
}

export default About